var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeySvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-1.32 0 47.135 47.135",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_19",
    "data-name": 19,
    d: "M116.833,623.959l2.159-2.158-3.314-3.314-2.158,2.159-3.466-3.466a7.895,7.895,0,1,0-8.126-12.478,6.319,6.319,0,1,0-8.77,9A7.894,7.894,0,1,0,106,621.565l3.3,3.3-1.826,1.825L110.788,630l1.826-1.826,8.754,8.754-4.807,4.806,1.65,1.65a2.457,2.457,0,1,1,3.382,3.382l1.979,1.979,4.807-4.807,2.347,2.348,4.219-4.219Zm-8.65-18.3a3.852,3.852,0,1,1-3.852,3.852A3.851,3.851,0,0,1,108.183,605.661Zm-2.277,11.415-.071.071c-.012-.035-.026-.069-.038-.1Zm-8.848-11.427a3.083,3.083,0,1,1-3.082,3.083A3.083,3.083,0,0,1,97.058,605.649ZM98.346,623.5a3.852,3.852,0,1,1,3.852-3.852A3.851,3.851,0,0,1,98.346,623.5Z",
    transform: "translate(-90.447 -601.614)",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeySvgrepoCom);
export default __webpack_public_path__ + "static/media/key-svgrepo-com.bcd17a4c9599615c80cedfe8293859ad.svg";
export { ForwardRef as ReactComponent };